import React from 'react';
import I18n from 'i18n-js';
import FollowButtonContainer from './discovery/feed/follow_button_container';
import { IFollowParams } from '@reverbdotcom/commons';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { FindFavoriteProvider } from './favorites/find_favorite_context';
import { FavoriteButtonContainer } from './favorites/favorite_button_container';

interface CSP2FeedCalloutProps {
  followParams: IFollowParams;
}

export function CSP2FeedCallout(props: CSP2FeedCalloutProps) {
  const user = useUser();
  const favoritesEnabled = isExperimentEnabled(user, experiments.FAVORITES);
  const favoriteButtonRQLEnabled = isExperimentEnabled(user, experiments.FAVORITE_BUTTON_RQL);

  return (
    <div className="scaling-mtb-3 scaling-padding-3 bg-offwhite bg--lighten bd-1 bd-primary align-center"
      data-feed-callout
    >
      { favoriteButtonRQLEnabled ? (
        <FindFavoriteProvider>
          <FavoriteButtonContainer
            displayStyle="banner"
          />
        </FindFavoriteProvider>
      ) : (
        <>
          { favoritesEnabled &&
              <h4 className="size-150 mobile-size-130 weight-bold pb-half">
                {I18n.t('discovery.addFollowToFeed.letGearComeToYou')}
              </h4>
          }
          <div className="scaling-mb-2 size-110">
            { favoritesEnabled ?
              I18n.t('discovery.favorites.saveSearchCallout') :
              I18n.t('discovery.csp2.feedCallout')
            }
          </div>
          <FollowButtonContainer
            withPriceFilters
            withUsedFilter
            followParams={props.followParams}
          />
        </>
      )}
    </div>
  );
}
